import { render, staticRenderFns } from "./alter-prescription-dialog.vue?vue&type=template&id=7476410a&scoped=true&lang=pug&"
import script from "./alter-prescription-dialog.vue?vue&type=script&lang=ts&"
export * from "./alter-prescription-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./alter-prescription-dialog.vue?vue&type=style&index=0&id=7476410a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7476410a",
  null
  
)

export default component.exports